<template>
  <div>

    <modal :show.sync="showShareInfo">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">分享成功</h5>
      </template>
      <div>
        取件编码:{{shareitem.url}}<br>
        密码:{{shareitem.password}}<br>
        分享链接:{{shareUrl}}<br>
      </div>
      <template slot="footer">
        <base-button type="primary" v-bind:aria-label="'奇乐云快传链接:'+shareUrl+'\n密码:'+shareitem.password" @click="showShareInfo = false">确定并复制</base-button>
      </template>
    </modal>

    <div class="card" style="margin: 10px 0px 0px 0px;">
      <div class="card-header d-flex align-items-center">
        <div class="d-flex align-items-center">
          <a href="#">
            <img src="/img/brand/logo.png" style="background-color: #fff;" class="avatar">
          </a>
          <div class="mx-3">
            <span style="font-size: 14px;">
              {{shareitem.files.length}}个文件和{{shareitem.dirs.length}}个文件夹（{{shareitem.download_times}}次下载，{{shareitem.save_times}}次转存，{{shareitem.show_times}}次浏览）
            </span>
            <small class="d-block text-muted">
              分享时间：{{shareitem.created_at}}
            </small>
          </div>

        </div>
        <div class="text-right ml-auto">
          <el-dropdown>
            <span style="margin-right: 10px;">
              <button type="button" class="btn btn-sm btn-outline-primary btn-icon">
                操作
              </button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div style="height: 100%;width: 100%;" @click="showShareInfo=true">查看链接和密码</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div style="height: 100%;width: 100%;" @click="addTime(shareitem.id)">续期</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div style="height: 100%;width: 100%;" @click="deleteShare(shareitem.id)">取消分享</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <button type="button" class="btn btn-sm btn-primary btn-icon" @click="switchContent()">
            <span v-if="show" class="btn-inner--text">收起</span>
            <span v-if="!show" class="btn-inner--text">展开</span>
          </button>
        </div>
      </div>
      <collapse-transition>
        <div v-show="show" class="card-body" style="padding: 0px!important;">
          <div class="">
            <el-table class="table-responsive table-flush" header-row-class-name="thead-light" row-key="id" :data="shareitem.dirs.concat(shareitem.files)"
              show-overflow-tooltip="true">

              <el-table-column label="文件名" min-width="500px" prop="name" sortable :show-overflow-tooltip="true"
                tooltip-effect="dark">
                <template v-slot="{row}">
                  <div>
                    <div style="display: flex;align-items: center;">
                      <file-icon style="width: 25px;height: 25px;flex-shrink: 0;" :filename="row.name" :type="row.hasOwnProperty('password')?'folder':'default'"></file-icon>
                      <span style="padding-left: 10px;">
                        <a v-if="!row.hasOwnProperty('password')" href="javascript:void(0)">{{row.name}}</a>
                        <a v-if="row.hasOwnProperty('password')" href="javascript:void(0)">{{row.name}}</a>
                      </span>
                    </div>
                  </div>

                </template>
              </el-table-column>

              <el-table-column label="修改日期" prop="updated_at" width="200px" sortable>
                <template v-slot="{row}">
                  {{row.updated_at}}
                </template>
              </el-table-column>

              <el-table-column label="大小" width="150px" prop="size" sortable>
                <template v-slot="{row}">
                  {{row.size?(row.size / 1048576).toFixed(2)+'M':"-"}}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </collapse-transition>
    </div>

  </div>



</template>
<script>
  import Bus from '@/components/Bus/bus.js'
  import {
    CollapseTransition
  } from 'vue2-transitions';
  import FileIcon from "@/components/FileIcon.vue"
  import Disk from '@/api/disk.js';
  import {
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Table,
    TableColumn,
    Tooltip,

  } from 'element-ui'
  export default {
    name: 'sharecard',
    props: {
      shareitem: {},
    },
    data() {
      return {
        show: false,
        showShareInfo: false,
        shareUrl: this.hostname + "/s/" + this.shareitem.url,
      }
    },
    components: {
      CollapseTransition,
      FileIcon,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    methods: {
      switchContent() {
        this.show = !this.show;
      },
      //续期分享
      addTime(id) {
        this.$store.commit("showLoading");
        Disk.addShareTime(id).then(res => {
          this.$msg({
            type: 'success',
            message: '续期成功'
          });
          Bus.$emit("refreshShareList");
        }).catch(err => {
          this.$msg({
            type: 'error',
            message: err.messages
          });
        }).finally(() => {
          this.$store.commit("hideLoading");
        })
      },
      //取消分享
      deleteShare(id) {
        this.$store.commit("showLoading");
        Disk.deleteShare(id).then(res => {
          this.$msg({
            type: 'success',
            message: '取消分享成功'
          });
          Bus.$emit("refreshShareList");
        }).catch(err => {
          this.$msg({
            type: 'error',
            message: err.messages
          });
        }).finally(() => {
          this.$store.commit("hideLoading");
        })
      }
    },
    mounted() {
      //console.log(shareitem);
      var clipboard = new ClipboardJS('.btn', {
        text: function(trigger) {
          return trigger.getAttribute('aria-label');
        }
      });

      clipboard.on('error', (e) => {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
      });

      clipboard.on('success', (e) => {
        this.$swal.fire(
          '复制成功',
          '您可以分享啦',
          'success'
        )
        e.clearSelection();
      });
    },
  }
</script>
<style>
</style>
